import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./header.jsx";
import Footer from "./footer.jsx";
import WebviewHandoff from "../common/WebviewHandoff.jsx";
import LiveScoreUpdates from "../common/liveScoreUpdates.jsx";

// Decides whether the shared ICC Header/Footer or TSP's own chrome (rendered
// per-route by TspLayout, see App.js) belongs around the current route.
// useLocation() requires Router context, which App() itself sits above, so
// this thin wrapper is the one thing rendered inside <Router>. WebviewHandoff
// keeps its exact prior, route-independent behavior; LiveScoreUpdates is the
// ICC marquee and is skipped on /tsp/* (see below).
export default function AppShell({ user, children }) {
  const location = useLocation();
  const isTspRoute = location.pathname.startsWith("/tsp");

  return (
    <>
      <WebviewHandoff />
      {!isTspRoute && user != null && <Header />}
      {/* TSP routes render their own chrome flush to the top of the viewport,
          so they skip ICC's fixed-header offset (.children-components) and
          the ICC live-score marquee that sits under the ICC header. */}
      <div className={isTspRoute && user != null ? "tsp-route-shell" : user !== null ? "children-components" : "login-background-image"}>
        {user != null && !isTspRoute && <LiveScoreUpdates />}
        {children}
      </div>
      {!isTspRoute && user != null && <Footer />}
    </>
  );
}
